import { render, staticRenderFns } from "./BuyVipView.vue?vue&type=template&id=3fa7ae6c&scoped=true&"
import script from "./BuyVipView.vue?vue&type=script&lang=js&"
export * from "./BuyVipView.vue?vue&type=script&lang=js&"
import style0 from "./BuyVipView.vue?vue&type=style&index=0&id=3fa7ae6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa7ae6c",
  null
  
)

export default component.exports